<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <img v-if="logo" :src="logo" class="sidebar-logo">
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img v-if="logo" :src="logo" class="sidebar-logo">
        <div class="sidebar-title-item">
          <h3 class="sidebar-sub-title">{{ title }}</h3>
          <h1 class="sidebar-title">{{ subTitle }} </h1>
        </div>
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title: '广州标定地价',
      subTitle: '信息管理系统',
      logo: require('@/assets/images/logo.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}
#app {
  .sidebar-container {
    .sidebar-logo-container {
      position: relative;
      width: 100%;
      height: 97px;
      background: #2b2f3a;
      text-align: center;
      overflow: hidden;
      display: flex;
      align-items: center;
      & .sidebar-logo-link {
        width: 100%;
        display: flex;
        align-items: center;
        color: #fff;
        text-align: left;
        & .sidebar-title-item {
          margin: 0 12px;
        }
        & .sidebar-logo {
          width: 50px;
          height: 50px;
          vertical-align: middle;
          margin-left: 14px;
          background-color: #fff;
          border-radius: 50%;
        }
        & .sidebar-sub-title,
        & .sidebar-title {
          font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
          line-height: 1.2;
          margin: 0;
        }
        & .sidebar-sub-title {
          font-size: 16px;

        }
        & .sidebar-title {
          font-size: 16px;
          letter-spacing: 4px;
        }
      }

      &.collapse {
        .sidebar-logo {
          margin: 0 auto;
          width: 30px;
          height: 30px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/Logo.vue